import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0de44d1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "element-loading-text": "正在保存数据，请稍后",
  style: {"min-height":"500px"}
}
const _hoisted_2 = { class: "cl-amount" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding":"0 20px","flex":"1 1 10%"} }, "至", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 保 存 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 关 闭 ")

import { reactive, ref, unref, onMounted } from 'vue';
import { ElMessage, FormRules, ElForm } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import UserSelect from '@/components/selected/Users/Index.vue';
import { useDictionary } from '@/store/dictionary.store';
import { GetRuleInfoApi, CatRuleCreateApi, CatRuleEditApi } from '@/apis/basics/rules/apis';
import { GetDeptListApi } from '../../../../apis/systems/systems.api';
import { GetCategoryTreeApi } from '@/apis/ct_categorys/category.api';
import { GetMainstaySelectApi } from '@/apis/basics/mainstay.api';
import { CatRulesBase } from '@/apis/basics/rules/dtos';


export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, { expose, emit: $emits }) {

const { getSelectList } = useDictionary();



const loading = ref<boolean>(false);
const isEditor = ref<boolean>(false);
const showDialog = ref<boolean>(false);

const mainstayList = ref<any[]>([]);

const elFormRef = ref<ComponentRef<typeof ElForm>>();

const state = reactive({
	categoryList: [],
	deptList: [],
	cascaderProps: { expandTrigger: 'hover', label: 'name', value: 'id', children: 'child', emitPath: false },
});

const formRules = reactive<FormRules>({
	node_id: [{ required: true, message: '审批节点不能留空', trigger: 'blur' }],
	rule_name: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
	mainstay_list: [{ required: true, message: '请选择规则适用主体', trigger: 'blur' }],
	category_id: [{ required: true, message: '请选择合同分类', trigger: 'blur' }],
});

const formSchema = ref<CatRulesBase>({
	id: '',
	revision: '',
	category_id: '',
	rule_name: '',
	is_enabled: 'Y',
	remark: '',
	node_id: '',
	amount_min: 0,
	amount_max: 0,
	tips: '',
	is_use_oa: 'N',
	specify_list: [],
	mainstay_list: [],
	dept_list: [],
});

/* 需要处理加载的数据 */
const load = {
	/* 我方主体选择数据 */
	getMainstaySelectList: async () => {
		const { succeeded, errors, data } = await GetMainstaySelectApi('');

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			mainstayList.value = data || [];
		}
	},

	/* 分类数据 */
	getCategoryTrees: async () => {
		const { succeeded, errors, data } = await GetCategoryTreeApi({});

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			state.categoryList = data || [];
		}
	},

	/* 获取部门列表 */
	getDeptList: async () => {
		const { succeeded, errors, data } = await GetDeptListApi({ search_key: '', mainstay_id: '' });

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			state.deptList = (data || []).map((item: any, idx: number) => {
				return { value: item.dept, label: item.dept_desc };
			});
		}
	},

	//     const options = Array.from({ length: 1000 }).map((_, idx) => ({
	//     value: `Option ${idx + 1}`,
	//     label: `${initials[idx % 10]}${idx}`,
	// }))
};

/* 获取合同分类信息 */
const getCategoryCfgInfo = async (rowId: string) => {
	loading.value = true;

	const { succeeded, errors, data } = await GetRuleInfoApi(rowId);

	if (!succeeded) {
		ElMessage.error(errors);
	} else {
		formSchema.value = data;
		// unref(formSchema).specify_list = data.specify_list || []
	}

	loading.value = false;
};

/* 用户操作 */
const actions = {
	/* 创建配置 */
	create: () => {
		formSchema.value = Object.assign({
			category_id: '',
			id: '',
			reactive: '0',
			rule_name: '',
			is_enabled: 'Y',
			remark: '',
			node_id: '',
			amount_min: 0,
			amount_max: 0,
			tips: '',
			is_use_oa: 'N',
			specify_list: [],
			mainstay_list: [],
			dept_list: [],
		});

		isEditor.value = false;
		loading.value = false;
		showDialog.value = true;
	},

	/* 修改配置 */
	modify: (rowId: string) => {
		getCategoryCfgInfo(rowId);

		isEditor.value = true;
		showDialog.value = true;
	},

	addDeptCfg: () => {
		unref(formSchema).dept_list?.push({ dept_id: '44', posts_list: [] });
	},
};

/* 点击保存按钮 */
const onSaveBtnClick = async () => {
	unref(elFormRef)?.validate(async (isValid: boolean) => {
		if (!isValid) return;

		loading.value = true;

		const formDatas = unref(formSchema);
		const apis = unref(isEditor) ? CatRuleEditApi : CatRuleCreateApi;
		const { succeeded, errors } = await apis(formDatas);

		loading.value = false;

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			ElMessage.success(`保存成功`);
			showDialog.value = false;
			$emits('success');
		}
	});
};

expose({ ...actions });

onMounted(() => {
	load.getMainstaySelectList();
	load.getCategoryTrees();
	load.getDeptList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: showDialog.value,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showDialog).value = $event)),
    title: isEditor.value ? '编辑配置' : '创建配置',
    style: {"width":"720px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        class: "w80",
        type: "primary",
        disabled: loading.value,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        size: "small",
        class: "w80",
        type: "info",
        disabled: loading.value,
        onClick: _cache[11] || (_cache[11] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          size: "small",
          ref_key: "elFormRef",
          ref: elFormRef,
          model: formSchema.value,
          "label-width": "100px",
          "label-position": "right",
          rules: _unref(formRules)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "规则名称",
                      prop: "rule_name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.rule_name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.rule_name) = $event)),
                          placeholder: "请输入规则名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "合同分类",
                      prop: "category_id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_cascader, {
                          modelValue: formSchema.value.category_id,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.category_id) = $event)),
                          props: _unref(state).cascaderProps,
                          options: _unref(state).categoryList,
                          clearable: "",
                          filterable: "",
                          style: {"width":"100%"},
                          placeholder: "请选择合同分类"
                        }, null, 8, ["modelValue", "props", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "适用主体",
                      prop: "mainstay_list"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          style: {"width":"100%"},
                          modelValue: formSchema.value.mainstay_list,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.mainstay_list) = $event)),
                          filterable: "",
                          "collapse-tags": "",
                          "collapse-tags-tooltip": "",
                          multiple: "",
                          placeholder: "请选择我方主体"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainstayList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "金额区间" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_el_input_number, {
                            style: {"flex":"1 1 45%"},
                            modelValue: formSchema.value.amount_min,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.amount_min) = $event)),
                            min: "0",
                            precision: 2
                          }, null, 8, ["modelValue"]),
                          _hoisted_3,
                          _createVNode(_component_el_input_number, {
                            style: {"flex":"1 1 45%"},
                            modelValue: formSchema.value.amount_max,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.amount_max) = $event)),
                            min: 0,
                            precision: 2
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "指定审批人员" }, {
                      default: _withCtx(() => [
                        _createVNode(UserSelect, {
                          modelValue: formSchema.value.specify_list,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.specify_list) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "审批节点",
                      prop: "node_id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formSchema.value.node_id,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.node_id) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectList)('OA_199'), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "提示信息",
                      prop: "tips"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "100",
                          modelValue: formSchema.value.tips,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.tips) = $event)),
                          rows: "2",
                          placeholder: "审批用户选择提示信息"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "备注",
                      prop: "remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "150",
                          modelValue: formSchema.value.remark,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.remark) = $event)),
                          rows: "3",
                          placeholder: "备注"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "是否启用",
                      prop: "is_enabled"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.is_enabled,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "使用OA配置",
                      prop: "is_use_od"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.is_use_oa,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formSchema.value.is_use_oa) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})